import { useSelector } from 'react-redux'
import { RootState } from '@/storage/store.ts'

// eslint-disable-next-line
const PRIVILEGES = [
  'programs_read',
  'roles_read',
  'roles_create',
  'roles_edit',
  'roles_delete',
  'dashboard_read',
  'applicants_read',
  'applicants_create',
  'applicants_edit',
  'applicants_delete',
  'appeals_read',
  'appeals_create',
  'appeals_edit',
  'appeals_delete',
  'task_list_view_read',
  'task_next_up_queue_read',
  'task_next_up_queue_edit',
  'scholarship_management_read',
  'provider_management_read',
  'provider_management_edit',
  'provider_management_create',
  'provider_management_delete',
  'ledger_control_read',
  'users_read',
  'users_create',
  'users_edit',
  'users_delete',
] as const

export type PrivilegeCode = (typeof PRIVILEGES)[number]

export const useUserPrivileges = () => {
  const userPrivileges = useSelector(
    (state: RootState) => state.auth.privileges
  )

  const defaultPrivileges = PRIVILEGES.reduce(
    (acc, privilege) => {
      acc[privilege] = false
      return acc
    },
    {} as Record<PrivilegeCode, boolean>
  )

  const privileges = userPrivileges
    ? PRIVILEGES.reduce(
        (acc, privilege) => {
          acc[privilege] = userPrivileges.includes(privilege)
          return acc
        },
        {} as Record<PrivilegeCode, boolean>
      )
    : defaultPrivileges

  return { user: privileges }
}
